export default {
  recruiters_fees: [],
}
